import { Routes, Route } from 'react-router-dom';

import { Layout } from './Layout';
import { MembersView } from './views/MembersView';
import { DataProvider } from './contexts/DataProvider';
// import { AlertProvider } from '@lendica/components';

export const Members = () => {
    return (
        // <AlertProvider>
        <DataProvider>
            <Routes>
                <Route
                    path="*"
                    element={
                        <Layout>
                            <MembersView />
                        </Layout>
                    }
                />
            </Routes>
        </DataProvider>
        // </AlertProvider>
    );
};
